// extracted by mini-css-extract-plugin
module.exports = {"container":"_3s0uMKjqaE9cJpItEVa-3M","visible":"_3hJfXAuBQ8xAfAlN4iqJV1","cancelBtn":"AAxUUIV_KJrEB88Y5CZoJ","icon":"kAnxrI7XSINxkMBAPnoOE","saveBtn":"Eo13qOmN19vzDw2J68eYx"};